export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AccordionItem.vue?vue&type=template&id=365d92d2&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/AccordionItem.vue?vue&type=template&id=365d92d2&scoped=true&
// module id = 197
// module chunks = 0